var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2143_835)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2143_835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3678 48.0546C37.5266 48.0546 48.1938 37.3873 48.1938 24.2286C48.1938 11.0699 37.5266 0.402588 24.3678 0.402588C11.2091 0.402588 0.54184 11.0699 0.54184 24.2286C0.54184 37.3873 11.2091 48.0546 24.3678 48.0546Z",
    fill: "#FF6900"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2143_835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3539 22.3437H24.3644L29.4685 20.6042C29.4894 20.5104 29.4894 20.4167 29.4894 20.3333C29.4894 20.2396 29.4789 20.1562 29.4477 20.0729C29.3644 19.8333 29.2081 19.5729 28.9894 19.3854V17.1042C28.9894 15.4167 28.3852 14.75 27.7602 14.3646C27.4373 13.3854 26.0935 12 23.4581 12C20.3331 12 17.9789 15.0937 17.9789 17.1042C17.9789 17.9375 17.9477 18.5937 17.9164 19.0937C17.9164 19.1979 17.906 19.2917 17.906 19.375C17.6769 19.5833 17.5206 19.8646 17.4477 20.1354C17.4373 20.1979 17.4269 20.2604 17.4269 20.3333C17.4269 21.1458 17.8852 22.3229 17.9477 22.4583C18.0102 22.6354 18.1456 22.7812 18.3227 22.8646C18.3331 22.9062 18.3435 22.9687 18.3435 23.0937C18.3435 24.1979 19.2914 25.2396 19.8123 25.7396C19.7602 26.8854 19.4373 27.6771 18.9789 27.875L14.8956 29.2292C13.7394 29.6146 12.8748 30.5521 12.5727 31.7396L12.0206 33.9479C11.9685 34.1771 12.0206 34.4271 12.1664 34.6146C12.3123 34.8021 12.5414 34.9167 12.781 34.9167H24.4581C24.1456 34.5208 23.8539 34.0833 23.5831 33.6146C22.8956 32.3958 22.4164 30.9167 22.4164 29.2396V25.0625C22.4164 23.8333 23.1977 22.75 24.3539 22.3437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4698 24.3189L31.001 22.4584C30.8385 22.4022 30.6615 22.4022 30.499 22.4584L25.0302 24.3189C24.7125 24.4262 24.5 24.723 24.5 25.0584V29.2439C24.5 34.3522 30.2021 36.8355 30.4448 36.9387C30.6406 37.0209 30.8594 37.0209 31.0552 36.9387C31.2979 36.8345 37 34.3522 37 29.2439V25.0584C37 24.723 36.7875 24.4262 36.4698 24.3189ZM34.1729 28.2689L31.3083 31.9147C30.9437 32.3803 30.2604 32.448 29.8115 32.0626L27.9885 30.5001C27.551 30.1262 27.5 29.4678 27.876 29.0314C28.25 28.5949 28.9083 28.5449 29.3437 28.9189L30.3417 29.7741L32.5344 26.9834C32.8896 26.5314 33.5437 26.4512 33.9969 26.8084C34.45 27.1616 34.5292 27.8168 34.1729 28.2689Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2143_835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.27002)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2143_835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.27002)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2143_835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.0d98606a39ece914501a6ad37fd7c4d2.svg";
export { ForwardRef as ReactComponent };